import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from '../../../node_modules/@mui/system/index';
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatisUngc = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PageHeader
                        title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons  imageKey="UNGC" title={"UNGC Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box
                    sx={{
                        borderRadius: '8px',
                        padding: '24px',
                        top: '226px',
                        left: '75px',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: '#2E7D32',
                            mb: 3,
                            fontFamily: 'DM Sans',
                            fontSize: '40px',
                            lineHeight: '38px',
                        }}
                    >
                        The global standards for sustainability<br /> impacts
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        <Typography
                            component="h4"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 800,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 1,
                            }}
                        >
                            What is UNGC? — Brief introduction
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                            }}
                        >
                            The United Nations Global Compact (UNGC) is the world’s largest corporate sustainability initiative, launched in 2000 to encourage businesses and organizations worldwide to adopt responsible practices and advance societal goals. It provides a voluntary framework centered on ten universal principles covering human rights, labor, the environment, and anti-corruption. Specifically, the UNGC calls on companies to support the protection of human rights, uphold fair labor standards including freedom of association and the elimination of forced or child labor, promote environmental responsibility through precautionary action and sustainable technologies, and combat all forms of corruption. Participating organizations commit to integrating these principles into their strategies, operations, governance, and risk management systems, while annually disclosing progress through a Communication on Progress (CoP) report. Beyond principle alignment, the UNGC encourages companies to contribute meaningfully to the United Nations Sustainable Development Goals (SDGs), enhancing their global impact, reputation, stakeholder trust, and long-term sustainability.
                        </Typography>
                    </Box>

                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <a
                        href="https://unglobalcompact.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                    >
                        <CustomButton title="Access to UNGC Document " />
                    </a>
                </Box>
            </Grid>
        </Grid>
    );
};

export default WhatisUngc;